if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        console.log('======================================');
        console.log('[BUNDLE DEBUG] ProductForm initialized');
        console.log('======================================');

        this.form = this.querySelector('form');

        if (!this.form) {
          console.error('[BUNDLE DEBUG] Product form not found.');
          return;
        }

        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        console.log(
          '[BUNDLE DEBUG] Raw bundle map:',
          this.dataset.bundleMap
        );

        try {
          const bundleMap = JSON.parse(
            this.dataset.bundleMap || '[]'
          );

          console.log(
            '[BUNDLE DEBUG] Parsed bundle map:',
            bundleMap
          );

          console.table(bundleMap);
        } catch (error) {
          console.error(
            '[BUNDLE DEBUG] Bundle map parsing error:',
            error
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        console.log('');
        console.log(
          '======================================'
        );
        console.log(
          '[BUNDLE DEBUG] ADD TO CART CLICKED'
        );
        console.log(
          '======================================'
        );

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          console.warn(
            '[BUNDLE DEBUG] Button disabled.'
          );

          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading__spinner'
          );

        if (spinner) {
          spinner.classList.remove(
            'hidden'
          );
        }

        const config =
          fetchConfig('javascript');

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];

        const formData =
          new FormData(this.form);

        const selectedVariantId =
          Number(
            formData.get('id')
          );

        const selectedQuantity =
          Number(
            formData.get('quantity') || 1
          );

        console.log(
          '[BUNDLE DEBUG] Main variant:',
          selectedVariantId
        );

        console.log(
          '[BUNDLE DEBUG] Main quantity:',
          selectedQuantity
        );

        let bundleMap = [];

        try {
          bundleMap =
            JSON.parse(
              this.dataset.bundleMap || '[]'
            );
        } catch (error) {
          console.error(
            '[BUNDLE DEBUG] Could not parse bundle map:',
            error
          );
        }

        const selectedVariantBundle =
          bundleMap.find(
            (item) =>
              Number(item.variant_id) ===
              selectedVariantId
          );

        console.log(
          '[BUNDLE DEBUG] Matching bundle:',
          selectedVariantBundle
        );

        let bundleVariantId =
          null;

        if (
          selectedVariantBundle
        ) {
          bundleVariantId =
            selectedVariantBundle.bundle_variant_id;
        }

        const sections =
          this.cart
            ? this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                )
            : [];

        /*
         * ==========================================
         * BUNDLE FOUND
         * ==========================================
         */

        if (
          bundleVariantId !== null &&
          bundleVariantId !== undefined &&
          Number(bundleVariantId) > 0
        ) {
          console.log('');
          console.log(
            '======================================'
          );
          console.log(
            '[BUNDLE DEBUG] BUNDLE FOUND'
          );
          console.log(
            '======================================'
          );

          const bundleFormData =
            new FormData();

          /*
           * MAIN PRODUCT
           */

          bundleFormData.append(
            'items[0][id]',
            selectedVariantId
          );

          bundleFormData.append(
            'items[0][quantity]',
            selectedQuantity
          );

          /*
           * COPY MAIN PRODUCT PROPERTIES
           */

          for (
            const [key, value]
            of formData.entries()
          ) {
            if (
              key === 'id' ||
              key === 'quantity' ||
              key === 'sections' ||
              key === 'sections_url'
            ) {
              continue;
            }

            if (
              key.startsWith(
                'properties['
              )
            ) {
              bundleFormData.append(
                `items[0][${key}]`,
                value
              );
            }
          }

          /*
           * BUNDLE PRODUCT
           */

          bundleFormData.append(
            'items[1][id]',
            Number(bundleVariantId)
          );

          bundleFormData.append(
            'items[1][quantity]',
            selectedQuantity
          );

          bundleFormData.append(
            'items[1][properties][_bundle_parent_variant_id]',
            selectedVariantId
          );

          bundleFormData.append(
            'items[1][properties][_is_bundle]',
            'true'
          );

          console.log(
            '[BUNDLE DEBUG] Bundle linked to main variant:',
            selectedVariantId
          );

          /*
           * IMPORTANT:
           * Mark this line as a bundle.
           */

          bundleFormData.append(
            'items[1][properties][_bundle_product]',
            'true'
          );

          /*
           * Tell the bundle which main
           * product/variant it belongs to.
           */

          const mainProductTitle =
            this.dataset.productTitle ||
            document.title;

          const selectedVariantText =
            this.getSelectedVariantText();

          bundleFormData.append(
            'items[1][properties][_bundle_for]',
            `${mainProductTitle}${selectedVariantText ? ' — ' + selectedVariantText : ''}`
          );

          /*
           * CART SECTIONS
           */

          if (this.cart) {
            bundleFormData.append(
              'sections',
              sections.join(',')
            );

            bundleFormData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(
              document.activeElement
            );
          }

          console.log(
            '[BUNDLE DEBUG] Bundle variant:',
            Number(bundleVariantId)
          );

          console.log(
            '[BUNDLE DEBUG] Bundle quantity:',
            selectedQuantity
          );

          console.log(
            '[BUNDLE DEBUG] Bundle properties added.'
          );

          console.log(
            '[BUNDLE DEBUG] Sending cart request...'
          );

          config.body =
            bundleFormData;
        }

        /*
         * ==========================================
         * NO BUNDLE
         * ==========================================
         */

        else {
          console.log(
            '[BUNDLE DEBUG] No bundle for this variant.'
          );

          if (this.cart) {
            formData.append(
              'sections',
              sections.join(',')
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );

            this.cart.setActiveElement(
              document.activeElement
            );
          }

          config.body =
            formData;
        }

        /*
         * ==========================================
         * SEND REQUEST
         * ==========================================
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then(
            (response) => {
              console.log(
                '[BUNDLE DEBUG] HTTP:',
                response.status
              );

              return response.json();
            }
          )

          .then(
            (response) => {
              console.log(
                '[BUNDLE DEBUG] SHOPIFY RESPONSE:',
                response
              );

              if (response.status) {
                console.error(
                  '[BUNDLE DEBUG] CART ERROR:',
                  response
                );

                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source:
                      'product-form',

                    productVariantId:
                      selectedVariantId,

                    errors:
                      response.errors ||
                      response.description,

                    message:
                      response.message,
                  }
                );

                this.handleErrorMessage(
                  response.description
                );

                this.error =
                  true;

                return;
              }

              if (!this.cart) {
                window.location =
                  window.routes.cart_url;

                return;
              }

              console.log(
                '[BUNDLE DEBUG] CART ADD SUCCESS'
              );

              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source:
                    'product-form',

                  productVariantId:
                    selectedVariantId,

                  cartData:
                    response,
                }
              );

              this.error =
                false;

              const quickAddModal =
                this.closest(
                  'quick-add-modal'
                );

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(
                        response
                      );
                    });
                  },
                  {
                    once: true,
                  }
                );

                quickAddModal.hide(
                  true
                );
              } else {
                this.cart.renderContents(
                  response
                );
              }
            }
          )

          .catch(
            (error) => {
              console.error(
                '[BUNDLE DEBUG] FETCH ERROR:',
                error
              );

              this.error =
                true;
            }
          )

          .finally(
            () => {
              console.log(
                '[BUNDLE DEBUG] ADD TO CART FINISHED'
              );

              this.submitButton.classList.remove(
                'loading'
              );

              if (
                this.cart &&
                this.cart.classList.contains(
                  'is-empty'
                )
              ) {
                this.cart.classList.remove(
                  'is-empty'
                );
              }

              /*
               * ======================================
               * FIX:
               * Re-enable Add to Cart button
               * after the request finishes.
               * ======================================
               */

              if (!this.error) {
                console.log(
                  '[BUNDLE DEBUG] Re-enabling Add to Cart button'
                );

                this.submitButton.removeAttribute(
                  'aria-disabled'
                );

                this.submitButton.removeAttribute(
                  'disabled'
                );

                console.log(
                  '[BUNDLE DEBUG] Button disabled:',
                  this.submitButton.disabled
                );

                console.log(
                  '[BUNDLE DEBUG] aria-disabled:',
                  this.submitButton.getAttribute(
                    'aria-disabled'
                  )
                );
              }

              const spinner =
                this.querySelector(
                  '.loading__spinner'
                );

              if (spinner) {
                spinner.classList.add(
                  'hidden'
                );
              }
            }
          );
      }

      /*
       * Get selected variant option text.
       *
       * This attempts to read the selected
       * product options from the product form.
       */

      getSelectedVariantText() {
        const values = [];

        const selects =
          this.form.querySelectorAll(
            'select'
          );

        selects.forEach(
          (select) => {
            if (select.value) {
              values.push(
                select.value
              );
            }
          }
        );

        const radios =
          this.form.querySelectorAll(
            'input[type="radio"]:checked'
          );

        radios.forEach(
          (radio) => {
            if (radio.value) {
              values.push(
                radio.value
              );
            }
          }
        );

        if (!values.length) {
          return '';
        }

        return ` (${values.join(
          ' / '
        )})`;
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper)
          return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButton.removeAttribute(
            'aria-disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}